<div class="if-checkbox-wrapper" [class.if-checkbox-wrapper--invalid]="isInvalid()">
  <label class="if-checkbox-label">
    <input
      type="checkbox"
      class="if-checkbox"
      [checked]="internalValue"
      [disabled]="isDisabled()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-invalid]="isInvalid() || null"
      (change)="onCheckboxChange($event)"
      (blur)="onBlur()" />
    <span class="if-checkbox-custom" [class.if-sm]="size() === 'sm'" [class.if-error]="variant() === 'error'" [class.if-boundarycondition]="variant() === 'boundarycondition'"></span>
    @if (label()) {
      <span class="if-checkbox-text" [innerHTML]="getSanitizedLabel()"></span>
    }
  </label>
</div>
